var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"js-timeline-entry timeline-entry note-container-query-wrapper"},[_c('div',{staticClass:"timeline-entry-inner gl-clearfix"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }